"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const joi_1 = __importDefault(require("joi"));
const errors_1 = require("../../errors");
class RateSummaryRequestValidator {
    _schama = joi_1.default.object({
        ids: joi_1.default.array().items(joi_1.default.string()).min(1).unique().required(),
    });
    validate(input) {
        const { error } = this._schama.validate(input, {
            abortEarly: false,
            convert: false,
        });
        if (error) {
            const issues = this.handleValidationError(error);
            if (issues.length > 0) {
                const validationError = new errors_1.ValidationError();
                issues.forEach((issue) => {
                    validationError.addIssue(issue.modelType, issue.errorCode, issue.fieldName, issue.value, issue.path);
                });
                throw validationError;
            }
        }
    }
    handleValidationError(error) {
        const issues = [];
        error.details.forEach((issue) => {
            switch (issue.type) {
                case 'any.required': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRateSummaryRequest', errors_1.Errors.ValidationErrorCode.requiredValue, issue.context?.key, undefined));
                    break;
                }
                case 'string.empty':
                case 'array.unique':
                case 'object.unknown': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRateSummaryRequest', errors_1.Errors.ValidationErrorCode.notAllowed, issue.context?.label, issue.context?.value));
                    break;
                }
                case 'object.base': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRateSummaryRequest', errors_1.Errors.ValidationErrorCode.invalidType, undefined, issue.context?.value));
                    break;
                }
                case 'string.base':
                case 'array.base': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRateSummaryRequest', errors_1.Errors.ValidationErrorCode.invalidType, issue.context?.label, issue.context?.value));
                    break;
                }
                case 'array.min':
                case 'any.only': {
                    issues.push(new errors_1.Errors.ValidationIssue('IRateSummaryRequest', errors_1.Errors.ValidationErrorCode.invalidValue, issue.context?.key, issue.context?.value));
                    break;
                }
            }
        });
        return issues;
    }
}
exports.default = RateSummaryRequestValidator;
